export default "__VITE_ASSET__280e2d2d__"